import { useState } from 'react';
import { Feather } from 'lucide-react';
import { DELOAD_STYLES } from './logic/deload';
import { FONT_BODY } from './theme';
import { Button, Card } from './ui';

const fmtDay = k => new Date(`${k}T12:00:00`).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
const HOW = {
  volume: 'Half the sets at about 90% of the weight',
  light: 'All sets at about 60% of the weight',
};

/* Today, while a deload runs: what it does and a way to stop it early. */
export function DeloadBanner({ t, deload, onEnd }) {
  return (
    <Card t={t} padding={14} style={{ display: 'flex', alignItems: 'center', gap: 12, background: t.accentSoft, borderColor: t.accentBorder }}>
      <Feather size={18} color={t.accent} style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: t.text }}>Deload until {fmtDay(deload.to)}</div>
        <div style={{ fontSize: 12, color: t.textMuted, marginTop: 2 }}>
          {HOW[deload.style]}. These sessions don't count towards trends or your next progression.
        </div>
      </div>
      <Button t={t} size="sm" variant="ghost" onClick={onEnd} style={{ minHeight: 40, flexShrink: 0 }}>End</Button>
    </Card>
  );
}

/* Start a deload: how long and which kind. */
export function DeloadStarter({ t, onStart, onCancel }) {
  const [days, setDays] = useState(7);
  const [style, setStyle] = useState('volume');
  const chip = on => ({
    flex: 1, minHeight: 40, borderRadius: 10, cursor: 'pointer', fontFamily: FONT_BODY, fontSize: 13, fontWeight: 600,
    border: `1px solid ${on ? t.accentBorder : t.cardBorder === 'transparent' ? t.divider : t.cardBorder}`,
    background: on ? t.accentSoft : 'transparent', color: on ? t.accent : t.text, padding: '6px 8px',
  });
  return (
    <Card t={t} padding={16}>
      <div style={{ fontSize: 14, fontWeight: 700, color: t.text }}>Deload</div>
      <div style={{ fontSize: 12, color: t.textMuted, margin: '4px 0 12px' }}>
        Targets get lighter, and these sessions are left out of trends and progression, so you pick up where you left off.
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        {[5, 7, 10].map(d => <button key={d} type="button" style={chip(days === d)} onClick={() => setDays(d)}>{d} days</button>)}
      </div>
      <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
        {Object.keys(DELOAD_STYLES).map(k => (
          <button key={k} type="button" style={chip(style === k)} onClick={() => setStyle(k)}>
            {DELOAD_STYLES[k].label}
            <div style={{ fontSize: 11, fontWeight: 500, color: t.textMuted, marginTop: 2 }}>{HOW[k]}</div>
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <Button t={t} variant="primary" onClick={() => onStart({ days, style })} style={{ minHeight: 44, flex: 1, justifyContent: 'center' }}>
          Start deload
        </Button>
        <Button t={t} variant="ghost" onClick={onCancel} style={{ minHeight: 44 }}>Cancel</Button>
      </div>
    </Card>
  );
}
